import React from "react";

import { useRemoveKeywordOfPressTitle } from "@hooks/useRemoveKeywordOfPressTitle";
import IconLink from "@images/pressClassification/icon-link-skyblue.svg";

import * as S from "./PressTitle.style";

interface Props {
  isLabel?: boolean;
  imageSrc?: string;
  contentTitle?: string;
  contentUrl?: string;
}

const PRESS_TITLE_LABEL = "Press Title";

const PressTitle = ({
  isLabel = true,
  imageSrc = IconLink,
  contentTitle,
  contentUrl,
}: Props) => {
  const { cleanedTitle } = useRemoveKeywordOfPressTitle(contentTitle || "");

  // NOTE: Patent 등 URL이 없는 경우 하이퍼링크(밑줄) 없이 타이틀만 표출
  const hasLink = Boolean(contentUrl);

  return (
    <S.PressTitleWrapper>
      {isLabel && <S.PressTitleLabel>{PRESS_TITLE_LABEL}</S.PressTitleLabel>}
      <S.PressTitle
        $hasLink={hasLink}
        onClick={() => hasLink && window.open(contentUrl, "_blank")}
      >
        <img src={imageSrc} alt="link" />
        <strong>{cleanedTitle}</strong>
      </S.PressTitle>
    </S.PressTitleWrapper>
  );
};

export default PressTitle;
